<template>
     <div id="main-content">
        <div class="top-block phone-no-border">
            <div class="selected-item">
                <div>
                    <span class="title">Настройки аккаунта</span>
                </div>
                <user-info></user-info>
            </div>
        </div>
        <div class="general-form">
            <form class="general" @submit.prevent="sendData">
                <div class="hide-xs">
                    <div class="input-group-inline">
                        <label>Текущий пароль</label>
                        <input type="password" v-model="old_password"
                               :class="{'error': errors.old_password}">
                        <div class="error-msg" v-if="errors.old_password">
                            {{errors.old_password}}</div>
                    </div>
                    <div class="input-group-inline">
                        <label>Новый пароль</label>
                        <input type="password" v-model="new_password"
                               :class="{'error': errors.new_password}">
                        <div class="error-msg" v-if="errors.new_password">
                            {{errors.new_password}}</div>
                    </div>
                    <div class="input-group-inline">
                        <label>Новый пароль еще раз</label>
                        <input type="password" v-model="new_password_confirmation"
                               :class="{'error': errors.new_password_confirmation}">
                        <div class="error-msg" v-if="errors.new_password_confirmation">
                            {{errors.new_password_confirmation}}</div>
                    </div>
                </div>

                <div class="hide-md">
                    <material-input v-model="old_password" :error="errors.old_password" type="password">
                        Текущий пароль</material-input>

                    <material-input v-model="new_password" :error="errors.new_password" type="password">
                        Новый пароль</material-input>

                    <material-input v-model="new_password_confirmation" :error="errors.new_password_confirmation" type="password">
                        Новый пароль еще раз</material-input>
                </div>

                <div class="submit-btns">
                    <button type="button" @click="$router.go(-1)">Отмена</button>
                    <button type="submit">Сохранить</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import userInfo from '../other/topUserInfo'
    import materialInput from '../../elements/material-input'


    export default {
        components:{
            userInfo,
            materialInput,
        },
        data() {
            return {
                snackbar: false,
                old_password: '',
                new_password: '',
                new_password_confirmation: '',
                errors:{
                    old_password: '',
                    new_password: '',
                }
            }
        },
        methods:{
            sendData(){
                axios.post('/login/changePassword',{
                    old_password: this.old_password,
                    new_password: this.new_password,
                    new_password_confirmation: this.new_password_confirmation,
                }).then((req)=>{ // данные проверены, убираем все ошибки из формы
                    _.forEach(this.errors, (v, k)=>{
                        this.errors[k] = '';
                    })
                    this.snackbar = true
                    this.old_password = ''
                    this.new_password = ''
                    this.new_password_confirmation = ''
                }).catch((req)=>{ // ошибки на этапе проверки данных
                    let data = req.response.data;
                    if(data.errors){
                        _.forEach(this.errors, (v, k)=>{
                            this.errors[k] = data.errors[k] ? data.errors[k].join('\n') : '';
                        })
                    }
                })
            },
        }
    }
</script>
